export default __webpack_public_path__ + "7f40e563f682a1ea3f4bf1c57c6b7b19.png";